import { SelectOption } from 'global';
import { LeadOption } from '../types';

export function convertLeadToOptions(options: LeadOption[] | undefined): SelectOption[] {
  if (!options || !options.length) return [];

  return options.map(({ value, businessName, contact, email, createdDateTime }) => ({
    value,
    label: [businessName, contact, email].filter(Boolean).join(' - ').concat(` (${createdDateTime})`),
  }));
}
